import { authenticatedApiFetch } from '../utils/utils'

export const allLevelsService = async () => {
    const res = await authenticatedApiFetch(`/levels/`)
		.then(response => response.json())
		.catch(error => console.error(error))
	return res
}
